'use client';

import { LogoutIcon } from '@components/icons';
import { Layout } from '@components/layout/Layout';
import { SiteLocale, SiteQuery, StringMultiLocaleField } from '@graphql/generated';
import { useAppContext } from '@lib/context/appContext';
import { getAlternativePaths, getLocales } from '@lib/utils/pathUtils';
import { TabAction } from '@src/types/tabAction';
import { getUserSession } from '@utils/local-storage';
import { usePathname, useRouter } from 'next/navigation';
import { ReactNode, useEffect, useState } from 'react';
import { TabButtons } from './TabsButtons';

type IProps = {
  params: { market: string; currency: string; lang: SiteLocale };
  layoutData: SiteQuery;
  cssBodyClass?: string;
  children: ReactNode;
};

export const AccountLayout = ({ params, layoutData, cssBodyClass = '', children }: IProps) => {
  const router = useRouter();
  const pathname = usePathname();
  const { dispatch } = useAppContext();
  const [loading, setLoading] = useState(true);
  const pageType = pathname.split('/').at(-1);
  const langs = getLocales();
  const alts = getAlternativePaths(
    'account',
    langs.map((l) => ({
      locale: l,
      value: pathname.split('/').slice(4).join('/'),
    })) as StringMultiLocaleField[]
  );

  useEffect(() => {
    const user = getUserSession();
    if (!user) {
      router.replace('/');
    } else {
      setLoading(false);
    }
  }, []);

  const ACCOUNT_ACTIONS: TabAction[] = [
    {
      label: 'Logout',
      icon: <LogoutIcon />,
      onClick: () => {
        dispatch({ type: 'TOGGLE_AUTH_MODAL', data: true });
      },
    },
  ];

  if (loading) {
    return null;
  }

  return (
    <Layout params={params} data={layoutData} alts={alts} cssBodyClass={cssBodyClass}>
      <div className="wrapper_account">
        <div className="account">
          <TabButtons
            locale={params.lang}
            actions={ACCOUNT_ACTIONS}
            showBack={pageType !== 'account'}
          />
          {children}
        </div>
      </div>
    </Layout>
  );
};
